export type DocumentUploadMode = "bundle" | "separate";

export const DEFAULT_DOCUMENT_UPLOAD_MODE: DocumentUploadMode = "bundle";

export function isBundleDocumentUploadMode(mode: DocumentUploadMode): boolean {
  return mode === "bundle";
}
